import { createSelector } from 'reselect';
import { unrecognizedPersistentBannerSelector } from 'selectors/testTarget/offers/unrecognizedPersistentBanner/unrecognizedPersistentBannerSelector';

const showSelector = createSelector(unrecognizedPersistentBannerSelector, unrecognizedPersistentBanner => !!unrecognizedPersistentBanner.show);

export { showSelector };
